export const config = {
  baseUrl: 'https://api.siho.com.uy/api/',
  locationUrl: 'https://direcciones.ide.uy/api/v0/geocode/',
};
